@use "../../styles/breakpoint.module.scss" as *;
@use "../../styles/layout.module.scss" as l;

.root {
    grid-column: margin;
    container-name: module;

    > :not(.carousel) {
        padding-inline: var(--spacer-margin);
    }
}

.carousel {
    display: flex;
    flex-direction: column;
}

.carouselScroller {
    scrollbar-width: none;
    margin-block: var(--spacer-40) var(--spacer-24);

    & > :first-child {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: repeat(4, max-content);
        row-gap: var(--spacer-24);

        & > * {
            grid-row: 1 / -1;
            display: grid;
            grid-template-rows: subgrid;
            padding-inline: calc(var(--spacer-gutter) / 2);

            &:first-of-type {
                padding-inline-start: var(--spacer-margin);
            }

            &:last-of-type {
                padding-inline-end: var(--spacer-margin);
            }
        }
    }
}

.slide {
    display: grid;
    grid-row: 1 / -1;
    grid-template-rows: subgrid;
    grid-template-columns: 1fr;
    grid-auto-flow: column;
    background: var(--white);
    width: l.span(3);
    padding: var(--spacer-24);
    align-items: start;
    justify-content: start;
    /* stylelint-disable declaration-block-no-redundant-longhand-properties */
    grid-template-areas:
        "top"
        "title"
        "details"
        "cta";
    /* stylelint-enable declaration-block-no-redundant-longhand-properties */

    @container style(--color-primary: var(--white)) {
        background: var(--neutral);

        --color-primary: var(--neutral);
    }

    @media ($below-desktop) {
        width: l.span(4);
    }

    @media ($below-mobile) {
        width: l.span(6);
        grid-template-columns: 1fr 4fr;
        grid-template-areas:
            "top title"
            "top details"
            "cta cta";
    }
}

.top {
    display: flex;
    align-items: start;
    justify-content: space-between;
    grid-area: top;

    @media ($below-mobile) {
        flex-direction: column;
        gap: var(--spacer-16);
    }
}

.headline {
    composes: fontHB80 from "../../styles/typography.module.scss";
    margin-block: var(--spacer-12);
}

.eyebrow {
    composes: fontST20 from "../../styles/typography.module.scss";
}

.dots {
    composes: dotsWrapper from "../Clickables/dots.module.scss";
}

.controls {
    composes: controls from "../ColumnCarousel/ColumnCarousel.module.scss";
    order: 3;
    margin-right: var(--spacer-margin);
}

.hiddenControls {
    composes: controls;
    display: none;
}

.bigMonth {
    composes: fontHB32 from "../../styles/typography.module.scss";
    text-transform: uppercase;
}

.bigDay {
    composes: fontHB104 from "../../styles/typography.module.scss";
}

.category {
    composes: fontST12 from "../../styles/typography.module.scss";
    justify-self: end;
    background: var(--color-contrast);
    color: var(--color-primary);
    padding: var(--spacer-4) var(--spacer-8);
    border-radius: var(--border-radius-sm);
}

.head {
    grid-area: title;
    margin-block: var(--spacer-24);

    @media ($below-mobile) {
        margin-block: 0;
    }
}

.eventTitle {
    composes: fontHB40 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-12);
}

.subtitle {
    composes: fontST20 from "../../styles/typography.module.scss";
}

.details {
    composes: fontST16 from "../../styles/typography.module.scss";
    grid-area: details;

    p {
        display: flex;
        flex-wrap: wrap;
        margin-block: var(--spacer-8);
    }
}

.cta {
    grid-area: cta;
}
